module.exports = __webpack_public_path__ + "img/blog.20008806.svg";